import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FinanceInvoiceDialogModel } from './model';
import { PopupService } from 'src/app/core/services/popup/popup.service';
import { FinanceService } from 'src/app/core/services/api/finance.service';

@Component({
  selector: 'app-finance-invoice-details',
  templateUrl: './finance-invoice-details.component.html',
  styleUrls: ['./finance-invoice-details.component.scss']
})
export class FinanceInvoiceDetailsComponent implements OnInit {
  invoices = [];

  constructor(
    public dialogRef: MatDialogRef<FinanceInvoiceDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FinanceInvoiceDialogModel,
    private financeService: FinanceService,
    private popupService: PopupService
  ) {}

  ngOnInit(): void {
    this.popupService.openProgress();
    this.getInvoiceDetails();
  }

  getInvoiceDetails() {
    const params = {
      id: this.data.id
    }
    this.financeService.getInvoiceDetails(params).subscribe(
      response => {
        this.invoices = response.data;
        this.popupService.closeProgress();
      },
      error => {
        this.popupService.closeProgress();
        this.popupService.openError(error.error.error.error);
      }
    )
  }

  close() {
    this.dialogRef.close();
  }

}
